import React, { useEffect, useMemo, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { IconDownload } from "../../icons/Icon";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuSearch from "../../utils/smu-search/SmuSearch";
import { prepareText, pascalCase } from "../../helpers";
import { COLOR_PRIMARY, COLOR_TEXT } from "../../constants/colors";
import SmuTable from "../../utils/smu-table/SmuTable";

const rowsStyle = {
  "&:hover": {
    backgroundColor: "#ededed",
  },
  cursor: "pointer",
};

const PromotionsTable = ({
  promotions,
  clickItem,
  setPromotions,
  selectedPromotions,
  download,
  loading
}) => {
  const handleAddPromotion = (event) => {
    const _code = event.target.value;
    const _check = event.target.checked;

    setPromotions((prevPromotions) => {
      if (!_check) return prevPromotions.filter((p) => p.ID_PROMO !== _code);
      const _promo = promotions.find((p) => p.ID_PROMO === _code);
      return [...prevPromotions, _promo];
    });
  };

  const handleAddAll = (event) => {
    if (event.target.checked) setPromotions(promotions.map((p) => p));
    else setPromotions([]);
  };

  const columns = useMemo(
    () => [
      {
        name: "Cod. Promo",
        selector: (row) => row.ID_PROMO,
        cell: (row) => (
          <div className="cell" onClick={() => clickItem(row)}>
            {row.ID_PROMO}
          </div>
        ),
        sortable: true,
      },
      {
        name: "Descripción Promoción",
        selector: (row) => row.DESCRIPCION_PROMO,
        cell: (row) => (
          <div className="cell" onClick={() => clickItem(row)}>
            {pascalCase(row.DESCRIPCION_PROMO)}
          </div>
        ),
        sortable: true,
      },
      {
        id: "FECHA_INICIO",
        name: "Inicio",
        selector: (row) => row.FECHA_INICIO,
        cell: (row) => (
          <div className="cell" onClick={() => clickItem(row)}>
            {row.FECHA_INICIO}
          </div>
        ),
        sortable: true,
      },
      {
        name: "Termino",
        selector: (row) => row.FECHA_TERMINO,
        cell: (row) => (
          <div className="cell" onClick={() => clickItem(row)}>
            {row.FECHA_TERMINO}
          </div>
        ),
        sortable: true,
      },
      {
        name: "Status",
        selector: (row) => row.ESTATUS,
        cell: (row) => (
          <div className="cell" onClick={() => clickItem(row)}>
            {pascalCase(row.ESTATUS)}
          </div>
        ),
        sortable: true,
      },
      {
        name: "Descargar",
        selector: (row) => row.CATALOGO,
        cell: (row) => (
          <div className="cell d-flex justify-content-end pe-5">
            <Form.Check
              type="checkbox"
              id={`checkbox-${row.CATALOGO}`}
              value={row.ID_PROMO}
              onChange={handleAddPromotion}
              checked={selectedPromotions
                .map((p) => p.ID_PROMO)
                .includes(row.ID_PROMO)}
            />
          </div>
        ),
      },
    ],
    [selectedPromotions, promotions]
  );

  const [search, setSearch] = useState("");
  const [filteredPromotions, setFilteredPromotions] = useState([]);

  useEffect(() => {
    let _promotions = promotions;

    if (search) {
      _promotions = _promotions.filter((p) => {
        const _search = prepareText(search);
        const _code = prepareText(p.ID_PROMO);
        const _desc = prepareText(p.DESCRIPCION_PROMO);
        const _start = prepareText(p.FECHA_INICIO);
        const _end = prepareText(p.FECHA_TERMINO);
        const _status = prepareText(p.ESTATUS);
        return (
          _code.includes(_search) ||
          _desc.includes(_search) ||
          _start.includes(_search) ||
          _end.includes(_search) ||
          _status.includes(_search)
        );
      });
    }

    setFilteredPromotions(_promotions);
  }, [search, promotions]);

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#B1E5FC" />
          <span className="fs-5 ms-3 me-auto">Promociones Super 10</span>
        </div>
        <div className="d-flex align-items-center mx-5">
          <SmuSearch
            value={search}
            onChange={({ target }) => setSearch(target.value)}
          />
        </div>
        <div className="d-flex align-items-center ms-3">
          <button
            className="btn btn-primary btn-sm ms-auto border-0"
            style={{ backgroundColor: COLOR_PRIMARY, color: COLOR_TEXT }}
            disabled={!selectedPromotions.length || !filteredPromotions.length}
            onClick={() => download()}
          >
            <span className="me-2">Excel</span>{" "}
            <IconDownload color={COLOR_TEXT} />
          </button>

          <Form.Check
            type="checkbox"
            id="checkbox-all"
            className="me-5 pe-1 ms-5"
            onChange={handleAddAll}
            disabled={!filteredPromotions.length}
          />
        </div>
      </Card.Header>
      <Card.Body>
        <SmuTable
          columns={columns}
          data={filteredPromotions}
          rowsStyle={rowsStyle}
          defaultSortFieldId="FECHA_INICIO"
          defaultSortAsc={false}
          loading={loading}
        />
      </Card.Body>
    </Card>
  );
};

export default PromotionsTable;
